import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import("./modules/auth/auth.module").then(module => module.AuthModule)
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/point-sale'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
